const STORAGE_KEY = 'og-banners:payment-alert-dismissed';

export function isPaymentAlertDismissed(): boolean {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    // Some browser privacy settings will throw when you try to retrieve stored data; assume not dismissed.
    return false;
  }
}

export function markPaymentAlertDismissed(): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // sessionStorage may be unavailable (e.g. Safari private mode); ignore.
  }
}
